<template>
  <div class="container-cap" id="tools-cohorts">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          Cohortes
        </h1>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div class="form-inline">
              <btn type="warning" @click="reset" :disabled="!ready">
                Remettre à zéro
              </btn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tabs v-model="tab" :transition-duration="0" v-if="ready">
      <tab title="Données">
        <sui-cohort-data-selector :availableDatasetsByYear="availableDatasetsByYear"
                                  :locked="dataLocked"
                                  @selected="selectData">
        </sui-cohort-data-selector>
      </tab>
      <tab title="Sélection des services" v-if="datasetsLoaded != null">
        <sui-cohort-unit-selector :data="data" @selected="selectDatasets">
        </sui-cohort-unit-selector>
      </tab>
      <tab v-if="data && data.selectionDatasets" title="Évolution">
        <sui-cohort-evolution :data="data">
        </sui-cohort-evolution>
      </tab>
    </tabs>
  </div>
</template>
<script>
import promise from '@/sui/tools/promise'

import suiCheckbox from '@/sui/components/checkbox'
import suiCohortDataSelector from '@/sui/components/cohort/dataselector'
import suiCohortUnitSelector from '@/sui/components/cohort/unitselector'
import suiCohortEvolution from '@/sui/components/cohort/evolution'

import datasetNames from '@/mixins/datasetNames'

import { mapState } from 'vuex'

export default {
  name: 'tools-cohorts',

  mixins: [ datasetNames ],

  data: function () {
    return {
      tab: 0,
      data: null,
      dataLocked: false,
      datasetsLoaded: null,
      modules: null,
      modulesLocked: false,
      ready: false
    }
  },

  watch: {
    datasetsLoaded: function (val, old) {
      if (old == null && val != null) {
        const vm = this
        this.$nextTick(() => { vm.tab = 1 })
      }
    },

    datasetListLoaded: function (val) {
      this.ready = true
    }
  },

  methods: {
    reset: function () {
      this.ready = false
      this.tab = 0
      this.data = null
      this.dataLocked = false
      this.datasetsLoaded = null
      this.modules = null
      this.modulesLocked = false
      const vm = this
      this.$nextTick(() => { vm.ready = true })
    },

    selectModules: function (m) {
      this.modules = m
      this.modulesLocked = true
    },

    selectDatasets: function (s) {
      this.data.selectionDatasets = s.selectionDatasets
      this.data.etypes = s.etypes
      this.tab = 2
    },

    selectData: function (d) {
      this.data = d
      this.dataLocked = true

      const vm = this
      this.$nextTick(() => vm.downloadDatasets())
    },

    downloadDatasets: function () {
      const promises = []
      const loaded = []
      const { mods, dsets } = this.data
      for (let y in dsets) {
        const c = dsets[y]
        if (c === '') {
          continue
        }

        promises.push(
          this.$store.dispatch('surveillances/all', y)
        )

        loaded[y] = c
        for (let i = 0; i !== mods.length; ++i) {
          const mod = mods[i]
          promises.push(
            this.$store.dispatch(
              'dataset/all',
              {
                name: c,
                mod: mod,
                step: 2,
                cache: true
              }
            )
          )
        }
      }
      const vm = this
      promise.awaitAll(
        promises,
        () => { vm.datasetsLoaded = loaded },
        (e) => {
          vm.$notify({
            type: 'danger',
            title: 'Erreur !',
            html: true,
            content: `Une erreur est survenue lors du téléchargement
des jeux de données : <ul><li>${e.join('</li><li>')}</li></ul>`,
            duration: 0
          })
          vm.data = null
          vm.datasetLocked = false
        }
      )
    }
  },

  computed: {
    ...mapState({
      all: state => state.surveillances.all
    })

  },

  mounted: function () {
    this.fillDatasetNames(false)
    this.ready = this.datasetListLoaded
  },

  components: {
    'sui-checkbox': suiCheckbox,
    'sui-cohort-evolution': suiCohortEvolution,
    'sui-cohort-data-selector': suiCohortDataSelector,
    'sui-cohort-unit-selector': suiCohortUnitSelector
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#tools-cohorts {
  min-height: 100rem;

  .nav-tabs {
    margin-bottom: 2rem;
  }
}

</style>
